<template>
  <tr v-if="requirement.editing" class="requirement row qualification-type editing" key="editing">
    <can I="edit" a="Opportunity">
      <th v-if="first" class="text-xs-right">Qualification</th>
      <td v-else class="text-xs-right">
        {{ requirement.mandatory ? 'and' : 'or' }}
      </td>
      <td colspan="2">
        <v-toolbar flat class="transparent">
          <v-select
            v-model="requirement.mandatory"
            :items="[{ text: 'must', value: true }, { text: 'could', value: false }]"
          />

          <label class="body px-2">be</label>

          <v-select
            v-model="requirement.negative"
            :items="[{ text: 'less than', value: true }, { text: 'at least', value: false }]"
          />

          <label class="body px-2">level</label>

          <v-text-field
            v-model="requirement.requiredLevel"
            class="required-level"
            @input="setValue"
            type="number"
          />

          <label class="body px-2">in</label>

          <v-select
            return-object
            v-model="requirement.country"
            :items="countries"
            item-text="name"
            item-value="code"
            @input="setValue"
          />

          <v-spacer />

          <!-- Cancel Button -->
          <v-tooltip left color="grey darken-3">
            <v-btn small flat fab slot="activator" @click="cancel" key="cancel" color="grey">
              <v-icon>mdi-cancel</v-icon>
            </v-btn>
            <span>Cancel</span>
          </v-tooltip>
          <!-- Delete Button -->
          <v-tooltip left v-if="requirement.id" color="grey darken-3">
            <v-btn small flat error fab slot="activator" @click="destroy" key="delete" color="error">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
          <!-- Submit Button -->
          <v-tooltip left>
            <v-btn small fab slot="activator" @click="submit" key="save" color="primary">
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
            <span v-if="requirement.id">Update</span>
            <span v-else>Create</span>
          </v-tooltip>
        </v-toolbar>
      </td>
    </can>
  </tr>
  <tr v-else class="requirement row qualification-type viewing" key="viewing">
    <th v-if="first" class="text-xs-right">Qualification</th>
    <td v-else class="text-xs-right">
      {{ requirement.mandatory ? 'and' : 'or' }}
    </td>
    <td>
      {{ requirement.mandatory ? 'must' : 'could' }}
      be
      {{ requirement.negative ? 'less than' : 'at least' }}
      a level of
      {{ requirement.requiredLevel }}
      in
      {{ requirement.country.name }}
    </td>
    <td class="text-xs-right">
      <can I="edit" a="Opportunity">
        <v-btn small flat @click.prevent="edit" color="primary">
          Edit
        </v-btn>
      </can>
    </td>
  </tr>
</template>

<script>
// Data
import countries from '@/data/countries'

// Vue Component
export default {
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean },
  },
  data() {
    return { countries }
  },
  computed: {
    creating() {
      return this.requirement.id == null
    },
  },
  methods: {
    edit() {
      this.requirement.editing = true
    },
    setValue() {
      this.requirement.value = `${this.requirement.country.code}:${this.requirement.requiredLevel}`
    },
    cancel() {
      this.$store.dispatch('opportunities/fetch', this.$route.params.id)
      this.requirement.editing = false
    },
    destroy() {
      if (this.requirement.id) {
        this.$store.dispatch('requirements/destroy', this.requirement)
      } else {
        this.$store.dispatch('opportunities/fetch', this.$route.params.id)
      }
    },
    submit() {
      if (this.requirement.id) {
        this.$store.dispatch('requirements/update', this.requirement).then(feedback => {
          if (feedback) {
            this.$store.commit('snackbar', {
              text: 'There was a problem updating the requirement',
              type: 'error',
            })
            this.requirement = feedback
          } else {
            this.$store.commit('snackbar', {
              text: 'Requirement was updated successfully',
              type: 'success',
            })
          }
        })
      } else {
        this.$store.dispatch('requirements/create', this.requirement).then(feedback => {
          if (feedback) {
            this.$store.commit('snackbar', {
              text: 'There was a problem creating the requirement',
              type: 'error',
            })
            this.requirement = feedback
          } else {
            this.$store.commit('snackbar', {
              text: 'Requirement was created successfully',
              type: 'success',
            })
          }
        })
      }
    },
  },
}
</script>

<style>
.required-level.input-group--text-field {
  max-width: 70px;
}
</style>
